import NotificationTargetsContainer from './NotificationTargetsContainer';

export default NotificationTargetsContainer;
